import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { MethodsDeleteDialog } from 'pages/Methods/components/MethodsDeleteDialog/MethodsDeleteDialog';
import { RaRecord, useEditController } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { CancelButton, DeleteButton, SaveButtonValidated } from 'shared/mui/Buttons';
import { EditGuesserPage } from 'shared/react-admin/Pages/EditGuesserPage/EditGuesserPage';
import { Method } from 'types/embedded/method';
import { Permission } from 'types/embedded/permission';

import { MethodsEditForm } from './MethodsEditForm/MethodsEditForm';
import { MethodsEditFormSkeleton } from './MethodsEditForm/MethodsEditFormSkeleton';

const transform = (data: RaRecord) => {
  return {
    ...data,
    logo: data.logo || null,
    methodType: data?.methodType?.['@id'] || null,
  };
};

export const MethodsEdit: React.FC = () => {
  const { record } = useEditController();
  const { hasResourcePermissions } = usePermissions();

  const { handleCloseRecordModal, openRecordModal, handleOpenRecordModal } =
    useRecordModal<Method>();

  return (
    <EditGuesserPage
      leftActionsSlot={
        hasResourcePermissions(Resources.Methods, [Permission.Full, Permission.Delete]) ? (
          <DeleteButton onClick={() => handleOpenRecordModal()} variant="outlined" />
        ) : undefined
      }
      listName="Методы"
      mutationOptions={{ onError: () => undefined }}
      rightActionsSlot={[
        <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
        <SaveButtonValidated key="save-button" label="Сохранить" />,
      ]}
      skeleton={<MethodsEditFormSkeleton />}
      title="Редактирование метода"
      transform={transform}
    >
      <Box sx={{ width: '100%', marginTop: '22px', marginBottom: '24px' }}>
        <MethodsEditForm />
      </Box>
      {openRecordModal && (
        <MethodsDeleteDialog
          onClose={handleCloseRecordModal}
          open={openRecordModal}
          record={record}
        />
      )}
    </EditGuesserPage>
  );
};
